import { takeEvery } from 'redux-saga/effects';
import { registerSagaWithAction } from './saga';

export default (pattern, saga, identifier, interval) =>
  takeEvery(pattern, registerSagaWithAction, saga, identifier, interval);
